<app-default-layout>
  <div class="container content">
    <div [outerHTML]="body"></div>
  </div>
</app-default-layout>
